<div class="editor">
  <app-inside-survey-building-layout-editor-canvas
    *ngIf="shown"
  ></app-inside-survey-building-layout-editor-canvas>
  <div class="editor-panel">
    <div class="panel-sections" [formGroup]="unitForm">
      <div class="input-sections">
        <div class="section">
          <span class="title" i18n="@@survey.inside.layouteditor.title.total"
            >TOTAL</span
          >
          <app-unit-info
            unitType="Floors"
            [minValue]="1"
            formControlName="floors"
          ></app-unit-info>
        </div>
        <div class="section">
          <span class="title" i18n="@@survey.inside.layouteditor.selectedfloors"
            >ON SELECTED FLOOR</span
          >
          <app-unit-info
            unitType="Units"
            formControlName="units"
            [minValue]="1"
          ></app-unit-info>
        </div>
      </div>
      <div class="section">
        <span
          class="title"
          i18n="@@survey.inside.layouteditor.title.selectedunits"
          >ON SELECTED UNIT</span
        >
        <div class="unit-selector">
          <div
            class="button unit"
            [class.unit-active]="isUnitTypeSelected(serviceUnit)"
            (click)="unitTypeSelectorClicked(serviceUnit)"
            draggable="true"
            (dragstart)="unitTypeSelectorDragStart(serviceUnit)"
            (dragend)="unitTypeSelectorDragEnd()"
          >
            SU
          </div>
          <div
            class="button unit"
            [class.unit-active]="isUnitTypeSelected(businessUnit)"
            (click)="unitTypeSelectorClicked(businessUnit)"
            draggable="true"
            (dragstart)="unitTypeSelectorDragStart(businessUnit)"
            (dragend)="unitTypeSelectorDragEnd()"
          >
            BU
          </div>
          <div
            class="button unit"
            [class.unit-active]="isUnitTypeSelected(livingUnit)"
            (click)="unitTypeSelectorClicked(livingUnit)"
            draggable="true"
            (dragstart)="unitTypeSelectorDragStart(livingUnit)"
            (dragend)="unitTypeSelectorDragEnd()"
          >
            LU
          </div>
          <div
            class="button unit"
            [class.unit-active]="isUnitTypeSelected(empty)"
            (click)="unitTypeSelectorClicked(empty)"
            draggable="true"
            (dragstart)="unitTypeSelectorDragStart(empty)"
            (dragend)="unitTypeSelectorDragEnd()"
            i18n="@@general.empty"
          >
            EMPTY
          </div>
          <div
            class="button unit"
            [class.unit-active]="isUnitTypeSelected(minusOne)"
            (click)="unitTypeSelectorClicked(minusOne)"
            draggable="true"
            (dragstart)="unitTypeSelectorDragStart(minusOne)"
            (dragend)="unitTypeSelectorDragEnd()"
          >
            -1
          </div>
        </div>
      </div>
      <div class="section spacer-section"></div>
      <div class="section button-section">
        <div class="undo-redo-container">
          <button
            class="button undo"
            [disabled]="!undoEnabled"
            (click)="undo()"
          >
            <mat-icon>undo</mat-icon>
            <span>undo</span>
          </button>
          <button
            class="button redo"
            [disabled]="!redoEnabled"
            (click)="redo()"
          >
            <mat-icon>redo</mat-icon>
            <span>redo</span>
          </button>
        </div>
        <button class="button save" [disabled]="saveDisabled" (click)="save()">
          <mat-icon class="material-icons-outlined">save</mat-icon>
          <span>save</span>
        </button>
      </div>
    </div>
  </div>
</div>
